import { Grid3x3, LayoutGrid, Rows3 } from "lucide-react";
import { cn } from "~/shared/lib/utils";
import { SECTION_V5 } from "./design-tokens";

export type SectionView = "card" | "table" | "grid";

export interface SectionViewSwitcherProps {
    value: SectionView;
    onChange: (next: SectionView) => void;
    className?: string;
    ariaLabel?: string;
    cardsLabel?: string;
    tableLabel?: string;
    gridLabel?: string;
    /** Show the dense-grid view button. Off by default so pages without a grid renderer stay 2-mode. */
    showGrid?: boolean;
}

export function SectionViewSwitcher({
    value,
    onChange,
    className,
    ariaLabel = "View",
    cardsLabel = "Cards",
    tableLabel = "Table",
    gridLabel = "Grid",
    showGrid = false,
}: SectionViewSwitcherProps) {
    return (
        <div role="tablist" aria-label={ariaLabel} className={cn(SECTION_V5.viewSwitcher, className)}>
            <button
                type="button"
                role="tab"
                aria-selected={value === "card"}
                aria-label={cardsLabel}
                data-active={value === "card"}
                onClick={() => onChange("card")}
                className={SECTION_V5.viewSwitcherItem}
            >
                <LayoutGrid className="size-4" aria-hidden />
                <span className="sr-only">{cardsLabel}</span>
            </button>
            {showGrid ? (
                <button
                    type="button"
                    role="tab"
                    aria-selected={value === "grid"}
                    aria-label={gridLabel}
                    data-active={value === "grid"}
                    onClick={() => onChange("grid")}
                    className={SECTION_V5.viewSwitcherItem}
                >
                    <Grid3x3 className="size-4" aria-hidden />
                    <span className="sr-only">{gridLabel}</span>
                </button>
            ) : null}
            <button
                type="button"
                role="tab"
                aria-selected={value === "table"}
                aria-label={tableLabel}
                data-active={value === "table"}
                onClick={() => onChange("table")}
                className={SECTION_V5.viewSwitcherItem}
            >
                <Rows3 className="size-4" aria-hidden />
                <span className="sr-only">{tableLabel}</span>
            </button>
        </div>
    );
}
